<template>
  <div
    class="min-h-[700px] tablet:min-h-[calc(100vh-320px)] laptop:min-h-[calc(100vh-375px)] desktop:min-h-[calc(100vh-205px)] largeDesktop:min-h-[calc(100vh-360px)]">
    <div v-if="!isLoading" :class="{'laptop:!grid-cols-2 laptop:!max-w-[750px]' : dashboardCard.length == 2,
      'laptop:!grid-cols-3' : dashboardCard.length == 3,
    }"
      class="relative z-10 grid grid-cols-2 laptop:grid-cols-4 gap-[20px] tablet:gap-[25px] laptop:gap-[30px] max-w-[95%] tablet:max-w-[80%] laptop:max-w-[890px] mx-auto">

      <component :id="'tour-' + item.label.toLowerCase().replace(/\s+/g, '-') " :is="'router-link'" :to="item.link" v-for="item in dashboardCard" :key="item.label"
      :class="{'tablet:!flex-row tablet:!justify-start tablet:!h-[100px] laptop:!h-[120px] tablet:pl-[20px]' : dashboardCard.length == 2,
        'tablet:!flex-row tablet:!justify-start tablet:!h-[100px] laptop:!h-[120px] tablet:pl-[10px]' : dashboardCard.length == 3,
      }"
        class="group no-underline flex flex-col items-center justify-center gap-[20px] shadow-[0px_0px_10px_0px_#cccccc61] py-[30px] tablet:py-0 w-full mobile:h-auto tablet:h-[180px] laptop:h-[200px] rounded-[20px] transition-all duration-300 cursor-pointer"
        :style="{ backgroundColor: isHover[item.label] ? item.bgColor : '#fff' }"
        @mouseenter="!isMobile && (isHover[item.label] = true)" @mouseleave="!isMobile && (isHover[item.label] = false)">
        <div
          class="w-[60px] h-[60px] tablet:w-[80px] tablet:h-[80px] flex items-center justify-center rounded-full transition-colors duration-300"
          :style="{ backgroundColor: isHover[item.label] ? '#fff' : item.bgColor }">
          <img :src="require(`@/assets/images/${item.icon}`)" :alt="item.label"
            class="w-[30px] h-[30px] laptop:w-[40px] laptop:h-[40px] object-contain" v-show="!isHover[item.label]" />
          <img :src="require(`@/assets/images/${item.hoverIcon}`)" :alt="item.label"
            class="w-[30px] h-[30px] laptop:w-[40px] laptop:h-[40px] object-contain" v-show="isHover[item.label]" />
        </div>
        <h6 class="m-0 text-[18px] tablet:text-[20px] font-roboto font-medium transition-colors duration-300"
          :style="{ color: isHover[item.label] ? '#fff' : '#333333' }">
          {{ item.label }}
        </h6>
      </component>
    </div>
  </div>
</template>

<script>
import { fas } from '@fortawesome/free-solid-svg-icons';

export default {
  data() {
    return {
      affiliateType: '',
      dashboardCard: [
        { icon: 'plan-icon.png', hoverIcon: 'plan-hovericon.png', bgColor: '#2359A8', label: 'Protection Plans', link: '/protection-plan/myhappyhome/products' },
        { icon: 'affiliates-icon.png', hoverIcon: 'affiliates-hovericon.png', bgColor: '#2359A8', label: 'Affiliates', link: '/affiliates' },
        { icon: 'sales_history-icon.png', hoverIcon: 'sales_history-hovericon.png', bgColor: '#2359A8', label: 'Sales History', link: '/protection-plan/sales-history' },
        { icon: 'commission-icon.png', hoverIcon: 'commission-hovericon.png', bgColor: '#2359A8', label: 'Commission', link: '/protection-plan/commissions' },
        // { icon: 'learning-hub-icon.png', hoverIcon: 'learning-hub-hoverIcon.png', bgColor: '#2359A8', label: 'Learning Hub', link: '/learning-hub' },
        { icon: 'commission-rules-icon.png', hoverIcon: 'commission-rule-hoverIcon.png', bgColor: '#2359A8', label: 'Commission Rules', link: '/protection-plan/commission-rules' },
      ],
      isHover: {},
      isLoading: true,
      isMobile: false,
    };
  },
  created() {


    let user_ = JSON.parse(localStorage.getItem('user'))
    this.affiliateType = user_.user.affiliate?.affiliate_type ?? 'master'

    if (this.affiliateType != 'master') {
      this.dashboardCard = this.dashboardCard.slice(0, -1);
    }
    if (this.affiliateType == 'employee') {
      this.dashboardCard = this.dashboardCard.filter(
        item => item.label !== 'Affiliates'
      );

      this.dashboardCard = this.dashboardCard.filter(
        item => item.label !== 'Commission'
      );
    }

    this.dashboardCard.forEach(item => {
      // Direct assignment works fine in Vue 2.7+
      this.isHover[item.label] = false;
    });

    this.isLoading = false
  },
  mounted() {
    this.isMobile = window.innerWidth < 1275;
  },
};
</script>
